module.exports = __webpack_public_path__ + "media/Aztec_Empire.ed8f2144.mp3";